import { render, staticRenderFns } from "./OwnerRealNameSection.vue?vue&type=template&id=6aefb351&scoped=true&"
import script from "./OwnerRealNameSection.vue?vue&type=script&lang=js&"
export * from "./OwnerRealNameSection.vue?vue&type=script&lang=js&"
import style0 from "./OwnerRealNameSection.vue?vue&type=style&index=0&id=6aefb351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefb351",
  null
  
)

export default component.exports